/**
 * @param {Array} countries -
 * @param {string} currentLang -
 * @returns {Array<{label: string, value: string}>}
 */
export function getUniqueSortedCountries(countries, currentLang) {
  if (!Array.isArray(countries)) return [];

  const uniqueCountriesMap = new Map();
  countries.forEach((item) => {
    const value = item?.concept_iri || item?.code;
    if (value && !uniqueCountriesMap.has(value)) {
      uniqueCountriesMap.set(value, item);
    }
  });

  const uniqueCountries = Array.from(uniqueCountriesMap.values());

  const transformed = uniqueCountries.map((item) => ({
    label:
      item?.label ||
      item?.langName?.[currentLang] ||
      item?.langName?.eng ||
      item?.concept_iri ||
      item?.code,
    value: item?.concept_iri || item?.code,
  }));

  return transformed.sort((a, b) =>
    a.label.localeCompare(b.label, currentLang)
  );
}
